import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalObject } from './modal-ref';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'dynamica-modal',
    templateUrl: './modal.component.html',
    styles: [],
    imports: [FormsModule, ReactiveFormsModule, TranslatePipe]
})

export class ModalComponent implements OnInit {

  @Input() formObject: ModalObject[];
  @Input() headerTitle;
  @Output() public closeModalEvent = new EventEmitter();
  @Output() public submitFunction = new EventEmitter();

  form: UntypedFormGroup;

  constructor() {
  }

  ngOnInit(): void {
    this.buildFormForModal(this.formObject);
  }

  closeModal(): void {
    this.closeModalEvent.emit(true);
  }

  onSubmit(): void {
    this.closeModal();
    this.submitFunction.emit(this.form.value);
  }

  buildFormForModal(formObjectData: ModalObject[]): void {
    this.form = new UntypedFormGroup(formObjectData.reduce((acc, field) => {
      acc[field.field] = new UntypedFormControl(field.initValue ? field.initValue : '');

      if (field.validationRequired && field.validationPattern) {
        acc[field.field].setValidators([Validators.required, Validators.pattern(field.validationPattern)]);
      } else if (field.validationRequired) {
        acc[field.field].setValidators(Validators.required);
      } else if (field.validationPattern) {
        acc[field.field].setValidators(Validators.pattern(field.validationPattern));
      }

      return acc;
    }, {}));
  }
}
